import React from 'react';
import ExpandableFupText from '../../components/common/ExpandableFupText/ExpandableFupText';
import styles from './Orchestrator.module.css';

export interface NewStudentAnamnesisFupSummaryProps {
  exerciseHistory: string | null | undefined;
  goalDetails: string | null | undefined;
}

const NewStudentAnamnesisFupSummary: React.FC<NewStudentAnamnesisFupSummaryProps> = ({
  exerciseHistory,
  goalDetails,
}) => {
  const normalizedExerciseHistory = exerciseHistory?.trim() ?? '';
  const normalizedGoalDetails = goalDetails?.trim() ?? '';

  if (!normalizedExerciseHistory && !normalizedGoalDetails) {
    return null;
  }

  return (
    <ExpandableFupText
      contentKey={`${normalizedExerciseHistory}\n${normalizedGoalDetails}`}
      className={styles['anamnesis-summary']}
    >
      {normalizedExerciseHistory && (
        <div className={styles['anamnesis-summary-section']}>
          <span className={styles['anamnesis-summary-title']}>Histórico de treino:</span>
          <span className={styles['anamnesis-summary-value']}>{normalizedExerciseHistory}</span>
        </div>
      )}
      {normalizedGoalDetails && (
        <div className={styles['anamnesis-summary-section']}>
          <span className={styles['anamnesis-summary-title']}>Objetivos:</span>
          <span className={styles['anamnesis-summary-value']}>{normalizedGoalDetails}</span>
        </div>
      )}
    </ExpandableFupText>
  );
};

export default NewStudentAnamnesisFupSummary;
